'use client';

import { createContext, useState, useContext, useEffect } from 'react';
import { useAuthContext } from '@/context';
import StripeConnectOnboardingModal from '@/components/modals/stripe-connect/StripeConnectOnboardingModal';
import { useAlertContext } from '@/context/alert';
import axios from 'axios';

// Create the cart context with default values
const StripeConnectAlertModalContext = createContext({
	showModal: false,
	SET_SHOW_MODAL: () => {},
	SET_HIDE_MODAL: () => {},
	SET_TOGGLE_MODAL: () => {},
});

// Create a provider component for the cart context
export const StripeConnectAlertModalProvider = ({ children }) => {
	const [showModal, setShowModal] = useState(false);

	const { SET_ALERT } = useAlertContext();

	const { auth } = useAuthContext();

	const SET_SHOW_MODAL = () => {
		setShowModal(true);
	};

	const SET_HIDE_MODAL = () => {
		localStorage.setItem('alreadyClosedStripeConnectModal', 'true');
		setShowModal(false);
	};

	const SET_TOGGLE_MODAL = () => {
		setShowModal(!showModal);
	};

	useEffect(() => {
		if (
			localStorage.getItem('alreadyClosedStripeConnectModal') !== 'true' &&
			window.location.pathname === '/seller-dashboard'
		) {
			setShowModal(true);
		}
	}, []);

	const [loadingStripeOnboarding, setLoadingStripeOnboarding] = useState(false);

	const startStripeOnbaording = async () => {
		if (loadingStripeOnboarding) return;
		setLoadingStripeOnboarding(true);
		await axios
			.get(
				`${process.env.NEXT_PUBLIC_SERVER_API}/api/payments/stripe-connect-onboarding`
			)
			.then((res) => {
				// Open in new tab
				window.open(res.data, '_blank');
			})
			.catch((err) => {
				console.log(err);
				SET_ALERT({
					message: 'Error starting Stripe onboarding',
					type: 'danger',
				});
			});

		setLoadingStripeOnboarding(false);
	};
	return (
		<StripeConnectAlertModalContext.Provider
			value={{
				showModal,
				SET_SHOW_MODAL,
				SET_HIDE_MODAL,
				SET_TOGGLE_MODAL,
				startStripeOnbaording,
			}}
		>
			{showModal &&
				!auth?.user?.stripeConnect?.connected &&
				!auth?.loading &&
				auth.isAuthenticated && (
					<StripeConnectOnboardingModal
						show={showModal}
						SET_HIDE_MODAL={SET_HIDE_MODAL}
						startStripeOnbaording={startStripeOnbaording}
						loadingStripeOnboarding={loadingStripeOnboarding}
					/>
				)}
			{children}
		</StripeConnectAlertModalContext.Provider>
	);
};

export const useStripeConnectAlertModalContext = () => {
	return useContext(StripeConnectAlertModalContext);
};
